import { Company } from 'module/api/company/types';
import { FieldAccessMeta } from 'module/api/field/types';
import { User } from 'module/api/user/types';
import { HttpClient } from 'api/http-client';
import { PageType, SourceType } from 'api/page-template/types';
import { SignalType } from 'api/signal/types';
import { AccountPeopleProfile } from './profile-type';
import {
  GetSignalOccurrenceGroupedForUserPayload,
  PeopleListRow,
  PeopleListV2,
  SignalFrequency,
  SignalOccurrenceGroupedForUser,
  SignalOccurrenceGroupedForUserPaginated,
} from './types';

const users = [
  {
    userName: 'sabareshkrishnamoorthysrinivasan',
    emailId: 'sabaresh.krishnamoorthysrinivasan@appviewx.com',
    userId: 363842,
    firstName: 'Sabaresh (Saba)',
    userType: 'EXTERNAL',
    accountId: 109,
    company: {
      companyId: 89943,
      companyName: 'AppViewX',
      companyLogoUrl: 'https://assets.rocketlane.com/109/appviewx.png',
      companyType: 'CUSTOMER',
      identityType: 'COMPANY',
      canTrackTime: false,
    },
    timeZone: 'Asia/Calcutta',
    role: {},
    userStatus: 'ACTIVE',
    identityType: 'USER',
    createdAt: 1732264380719,
    loginType: 'USER',
    metaData: {
      '1355746': true,
    },
    fields: [
      {
        fieldId: 1355746,
        fieldName: 'AddedtoHubSpot_1355746',
        fieldValue: true,
        fieldLabel: 'Added to HubSpot?',
      },
    ],
    capacity: 40,
    capacityMinutes: 2400,
    defaultCapacity: true,
    meetingRecordingEnabled: false,
    calendarStatus: 'NOT_CONNECTED',
  },
  {
    userName: 'jamesmartin',
    emailId: 'james.martin@godocs.com',
    userId: 496867,
    photoUrl:
      'https://d1vtr0p8bkmfca.cloudfront.net/109/16483cee-f0ac-47d1-a7ea-ba70fbb99d1f/1647096428080.jpg',
    firstName: 'James',
    lastName: 'Martin',
    userType: 'EXTERNAL',
    accountId: 109,
    company: {
      companyId: 435022,
      companyName: 'GoDocs - New Deal',
      companyLogoUrl:
        'https://d1vtr0p8bkmfca.cloudfront.net/109/74e1b2e7-30cf-4fe1-bd0b-d038226a47d0/godocs.png',
      identityType: 'COMPANY',
      canTrackTime: false,
    },
    timeZone: 'America/Los_Angeles',
    role: {},
    fields: [
      {
        fieldId: 1355746,
        fieldName: 'AddedtoHubSpot_1355746',
        fieldValue: true,
        fieldLabel: 'Added to HubSpot?',
      },
    ],
    userStatus: 'ACTIVE',
    identityType: 'USER',
    createdAt: 1750952947072,
    loginType: 'USER',
    capacity: 40,
    capacityMinutes: 2400,
    defaultCapacity: true,
  },
  {
    userName: 'jaffar',
    emailId: 'jaffar@everstage.com',
    userId: 365309,
    firstName: 'jaffar',
    userType: 'EXTERNAL',
    accountId: 109,
    company: {
      companyId: 13090,
      companyName: 'Everstage',
      companyLogoUrl:
        'https://d1vtr0p8bkmfca.cloudfront.net/109/e4df1e6d-e753-4b8f-bd61-b0d8619df5b3/images.png',
      companyType: 'CUSTOMER',
      identityType: 'COMPANY',
      canTrackTime: false,
    },
    timeZone: 'Asia/Calcutta',
    role: {},
    userStatus: 'ACTIVE',
    identityType: 'USER',
    createdAt: 1732623724658,
    loginType: 'USER',
    metaData: {
      '1355746': true,
    },
    fields: [
      {
        fieldId: 1355746,
        fieldName: 'AddedtoHubSpot_1355746',
        fieldValue: true,
        fieldLabel: 'Added to HubSpot?',
      },
    ],
    capacity: 40,
    capacityMinutes: 2400,
    defaultCapacity: true,
    meetingRecordingEnabled: false,
    calendarStatus: 'NOT_CONNECTED',
  },
  {
    userName: 'supratimb',
    emailId: 'supratim.b@darwinbox.in',
    userId: 348465,
    firstName: 'Supratim',
    lastName: 'Barua',
    userType: 'EXTERNAL',
    accountId: 109,
    company: {
      companyId: 205782,
      companyName: 'DarwinBox',
      companyLogoUrl:
        'https://d1vtr0p8bkmfca.cloudfront.net/109/9e19c2a2-c7df-4f36-9840-05e606d4da61/thedarwinbox_logo.jpeg',
      companyType: 'CUSTOMER',
      identityType: 'COMPANY',
      canTrackTime: false,
    },
    timeZone: 'Asia/Calcutta',
    role: {},
    userStatus: 'ACTIVE',
    identityType: 'USER',
    createdAt: 1729765654736,
    loginType: 'USER',
    metaData: {
      '1355746': true,
    },
    fields: [
      {
        fieldId: 1355746,
        fieldName: 'AddedtoHubSpot_1355746',
        fieldValue: true,
        fieldLabel: 'Added to HubSpot?',
      },
    ],
    capacity: 40,
    capacityMinutes: 2400,
    defaultCapacity: true,
    meetingRecordingEnabled: false,
    calendarStatus: 'NOT_CONNECTED',
  },
  {
    userName: 'chandniarneja',
    emailId: 'chandni.arneja@jombay.com',
    userId: 273872,
    firstName: 'chandniarneja',
    lastName: 'arneja',
    userType: 'EXTERNAL',
    accountId: 109,
    company: {
      companyId: 173051,
      companyName: 'Jombay ',
      companyLogoUrl:
        'https://d1vtr0p8bkmfca.cloudfront.net/109/e199a564-1604-4d9c-ab32-1c43cf34476d/512x512bb.jpg',
      companyType: 'CUSTOMER',
      identityType: 'COMPANY',
      canTrackTime: false,
    },
    timeZone: 'Asia/Calcutta',
    role: {},
    userStatus: 'ACTIVE',
    identityType: 'USER',
    createdAt: 1715255895421,
    loginType: 'USER',
    metaData: {
      '1040251': 1,
    },
    fields: [
      {
        fieldId: 1040251,
        fieldName: 'contactType',
        fieldValue: 1,
        metaFieldValue: {
          color: 'cool-gray',
          label: 'Champion',
          value: 1,
          group: 2,
          active: true,
          deletable: false,
          editable: false,
        },
        fieldLabel: 'Contact Type',
      },
    ],
    capacity: 40,
    capacityMinutes: 2400,
    defaultCapacity: true,
    reportingTo: 273876,
    managerOf: [],
    meetingRecordingEnabled: false,
    calendarStatus: 'NOT_CONNECTED',
  },
  {
    userName: 'nitin',
    emailId: 'nitin@jombay.com',
    userId: 273874,
    firstName: 'Nitin',
    lastName: 'Srivastava',
    userType: 'EXTERNAL',
    accountId: 109,
    company: {
      companyId: 173051,
      companyName: 'Jombay ',
      companyLogoUrl:
        'https://d1vtr0p8bkmfca.cloudfront.net/109/e199a564-1604-4d9c-ab32-1c43cf34476d/512x512bb.jpg',
      companyType: 'CUSTOMER',
      identityType: 'COMPANY',
      canTrackTime: false,
    },
    timeZone: 'Asia/Calcutta',
    role: {},
    userStatus: 'ACTIVE',
    identityType: 'USER',
    createdAt: 1715255903228,
    loginType: 'USER',
    metaData: {
      '1040251': 1,
    },
    fields: [
      {
        fieldId: 1040251,
        fieldName: 'contactType',
        fieldValue: 1,
        metaFieldValue: {
          color: 'cool-gray',
          label: 'Champion',
          value: 1,
          group: 2,
          active: true,
          deletable: false,
          editable: false,
        },
        fieldLabel: 'Contact Type',
      },
    ],
    capacity: 40,
    capacityMinutes: 2400,
    defaultCapacity: true,
    reportingTo: 273876,
    managerOf: [],
    meetingRecordingEnabled: false,
    calendarStatus: 'NOT_CONNECTED',
  },
  {
    userName: 'natashahawkins',
    emailId: 'natasha.hawkins@fluxxlabs.com',
    userId: 366942,
    firstName: 'natashahawkins',
    userType: 'EXTERNAL',
    accountId: 109,
    company: {
      companyId: 68385,
      companyName: 'Fluxx',
      companyLogoUrl: 'https://assets.rocketlane.com/fluxxlabs.png',
      companyType: 'CUSTOMER',
      identityType: 'COMPANY',
      canTrackTime: false,
    },
    timeZone: 'America/Los_Angeles',
    role: {},
    userStatus: 'ACTIVE',
    identityType: 'USER',
    createdAt: 1732873165116,
    loginType: 'USER',
    metaData: {
      '1355746': true,
    },
    fields: [
      {
        fieldId: 1355746,
        fieldName: 'AddedtoHubSpot_1355746',
        fieldValue: true,
        fieldLabel: 'Added to HubSpot?',
      },
    ],
    capacity: 40,
    capacityMinutes: 2400,
    defaultCapacity: true,
    meetingRecordingEnabled: false,
    calendarStatus: 'NOT_CONNECTED',
  },
  {
    userName: 'miles',
    emailId: 'miles@rivethealth.com',
    userId: 367097,
    firstName: 'miles',
    userType: 'EXTERNAL',
    accountId: 109,
    company: {
      companyId: 100951,
      companyName: 'Rivet Health',
      companyLogoUrl:
        'https://d1vtr0p8bkmfca.cloudfront.net/109/46ac96e4-641e-485a-8af9-3de7c7d3e195/rivetlogo.jpeg',
      companyType: 'CUSTOMER',
      identityType: 'COMPANY',
      canTrackTime: false,
    },
    timeZone: 'America/Denver',
    role: {},
    userStatus: 'ACTIVE',
    identityType: 'USER',
    createdAt: 1732953847457,
    loginType: 'USER',
    metaData: {
      '1355746': true,
    },
    fields: [
      {
        fieldId: 1355746,
        fieldName: 'AddedtoHubSpot_1355746',
        fieldValue: true,
        fieldLabel: 'Added to HubSpot?',
      },
    ],
    capacity: 40,
    capacityMinutes: 2400,
    defaultCapacity: true,
    meetingRecordingEnabled: false,
    calendarStatus: 'NOT_CONNECTED',
  },
  {
    userName: 'jschnur',
    emailId: 'jschnur@moveworks.ai',
    userId: 154088,
    firstName: 'Jake',
    userType: 'EXTERNAL',
    accountId: 109,
    company: {
      companyId: 86286,
      companyName: 'Moveworks',
      companyLogoUrl:
        'https://d1vtr0p8bkmfca.cloudfront.net/109/2b716af8-f027-4e61-8d16-991d48f2bd4f/310039550_526820689448244_7795817900844398920_n.jpg',
      companyType: 'CUSTOMER',
      identityType: 'COMPANY',
      canTrackTime: false,
    },
    timeZone: 'America/Los_Angeles',
    role: {},
    userStatus: 'ACTIVE',
    identityType: 'USER',
    createdAt: 1687221556266,
    loginType: 'USER',
    metaData: {
      '1040251': 1,
    },
    fields: [
      {
        fieldId: 1040251,
        fieldName: 'contactType',
        fieldValue: 1,
        metaFieldValue: {
          color: 'cool-gray',
          label: 'Champion',
          value: 1,
          group: 2,
          active: true,
          deletable: false,
          editable: false,
        },
        fieldLabel: 'Contact Type',
      },
    ],
    capacity: 40,
    capacityMinutes: 2400,
    defaultCapacity: true,
    reportingTo: 154093,
    managerOf: [],
    meetingRecordingEnabled: false,
    calendarStatus: 'NOT_CONNECTED',
  },
  {
    userName: 'rnarayanan',
    emailId: 'rnarayanan@moveworks.ai',
    userId: 153598,
    firstName: 'Ranga',
    lastName: 'Narayanan',
    userType: 'EXTERNAL',
    accountId: 109,
    company: {
      companyId: 86286,
      companyName: 'Moveworks',
      companyLogoUrl:
        'https://d1vtr0p8bkmfca.cloudfront.net/109/2b716af8-f027-4e61-8d16-991d48f2bd4f/310039550_526820689448244_7795817900844398920_n.jpg',
      companyType: 'CUSTOMER',
      identityType: 'COMPANY',
      canTrackTime: false,
    },
    timeZone: 'America/Los_Angeles',
    role: {},
    userStatus: 'ACTIVE',
    identityType: 'USER',
    createdAt: 1686925394967,
    loginType: 'USER',
    metaData: {
      '1040251': 1,
    },
    fields: [
      {
        fieldId: 1040251,
        fieldName: 'contactType',
        fieldValue: 1,
        metaFieldValue: {
          color: 'cool-gray',
          label: 'Champion',
          value: 1,
          group: 2,
          active: true,
          deletable: false,
          editable: false,
        },
        fieldLabel: 'Contact Type',
      },
    ],
    capacity: 40,
    capacityMinutes: 2400,
    defaultCapacity: true,
    reportingTo: 154093,
    managerOf: [],
    meetingRecordingEnabled: false,
    calendarStatus: 'NOT_CONNECTED',
  },
  {
    userName: 'vamsik',
    emailId: 'vamsi.k@darwinbox.in',
    userId: 348429,
    firstName: 'vamsi',
    lastName: 'krishna',
    userType: 'EXTERNAL',
    accountId: 109,
    company: {
      companyId: 205782,
      companyName: 'DarwinBox',
      companyLogoUrl:
        'https://d1vtr0p8bkmfca.cloudfront.net/109/9e19c2a2-c7df-4f36-9840-05e606d4da61/thedarwinbox_logo.jpeg',
      companyType: 'CUSTOMER',
      identityType: 'COMPANY',
      canTrackTime: false,
    },
    timeZone: 'Asia/Calcutta',
    role: {},
    userStatus: 'ACTIVE',
    identityType: 'USER',
    createdAt: 1729761171988,
    loginType: 'USER',
    metaData: {
      '1355746': true,
    },
    fields: [
      {
        fieldId: 1355746,
        fieldName: 'AddedtoHubSpot_1355746',
        fieldValue: true,
        fieldLabel: 'Added to HubSpot?',
      },
    ],
    capacity: 40,
    capacityMinutes: 2400,
    defaultCapacity: true,
    meetingRecordingEnabled: false,
    calendarStatus: 'NOT_CONNECTED',
  },
  {
    userName: 'apurvapattela',
    emailId: 'apurva.pattela@practo.com',
    userId: 362345,
    firstName: 'apurva',
    lastName: 'pattela',
    userType: 'EXTERNAL',
    accountId: 109,
    company: {
      companyId: 249388,
      companyName: 'Practo ',
      companyLogoUrl:
        'https://d1vtr0p8bkmfca.cloudfront.net/109/b30124e5-51ab-4149-8f08-02d4016dd904/images%20%282%29.jpeg',
      companyType: 'CUSTOMER',
      identityType: 'COMPANY',
      canTrackTime: false,
    },
    timeZone: 'Asia/Calcutta',
    role: {},
    userStatus: 'ACTIVE',
    identityType: 'USER',
    createdAt: 1732096368643,
    loginType: 'USER',
    metaData: {
      '1355746': false,
    },
    fields: [
      {
        fieldId: 1355746,
        fieldName: 'AddedtoHubSpot_1355746',
        fieldValue: false,
        fieldLabel: 'Added to HubSpot?',
      },
    ],
    capacity: 40,
    capacityMinutes: 2400,
    defaultCapacity: true,
    meetingRecordingEnabled: false,
    calendarStatus: 'NOT_CONNECTED',
  },
  {
    userName: 'ayshaarif',
    emailId: 'aysha.arif@sysaid.com',
    userId: 361300,
    firstName: 'Aysha',
    lastName: 'Arif',
    userType: 'EXTERNAL',
    accountId: 109,
    company: {
      companyId: 134974,
      companyName: 'sysaid',
      companyLogoUrl:
        'https://d1vtr0p8bkmfca.cloudfront.net/109/7d1421a1-fb93-460f-bd40-f4daf4ce6a7c/download.png',
      companyType: 'CUSTOMER',
      identityType: 'COMPANY',
      canTrackTime: false,
    },
    timeZone: 'America/Toronto',
    role: {},
    userStatus: 'ACTIVE',
    identityType: 'USER',
    createdAt: 1731951687854,
    loginType: 'USER',
    metaData: {
      '1820884': '<p>Old POC</p>',
    },
    fields: [
      {
        fieldId: 1820884,
        fieldName: 'Notes_1820884',
        fieldValue: '<p>Old POC</p>',
        fieldLabel: 'Notes',
      },
    ],
    capacity: 40,
    capacityMinutes: 2400,
    defaultCapacity: true,
    meetingRecordingEnabled: false,
    calendarStatus: 'NOT_CONNECTED',
  },
  {
    userName: 'shoubhikr',
    emailId: 'shoubhik.r@zluri.com',
    userId: 362341,
    firstName: 'Shoubhik',
    lastName: 'Roy',
    userType: 'EXTERNAL',
    accountId: 109,
    company: {
      companyId: 82516,
      companyName: 'Zluri',
      companyLogoUrl: 'https://assets.rocketlane.com/109/zluri.png',
      companyType: 'CUSTOMER',
      identityType: 'COMPANY',
      canTrackTime: false,
    },
    timeZone: 'Asia/Calcutta',
    role: {},
    userStatus: 'ACTIVE',
    identityType: 'USER',
    createdAt: 1732095646084,
    loginType: 'USER',
    metaData: {
      '1355746': true,
    },
    fields: [
      {
        fieldId: 1355746,
        fieldName: 'AddedtoHubSpot_1355746',
        fieldValue: true,
        fieldLabel: 'Added to HubSpot?',
      },
    ],
    capacity: 40,
    capacityMinutes: 2400,
    defaultCapacity: true,
    meetingRecordingEnabled: false,
    calendarStatus: 'NOT_CONNECTED',
  },
  {
    userName: 'dimplesharma',
    emailId: 'dimple.sharma@webengage.com',
    userId: 362377,
    firstName: 'Dimple',
    lastName: 'Sharma',
    userType: 'EXTERNAL',
    accountId: 109,
    company: {
      companyId: 1524,
      companyName: 'Webengage',
      companyLogoUrl: 'https://assets.rocketlane.com/webengage.png',
      companyType: 'CUSTOMER',
      identityType: 'COMPANY',
      canTrackTime: false,
    },
    timeZone: 'Asia/Calcutta',
    role: {},
    userStatus: 'ACTIVE',
    identityType: 'USER',
    createdAt: 1732097034012,
    loginType: 'USER',
    metaData: {
      '1355746': true,
    },
    fields: [
      {
        fieldId: 1355746,
        fieldName: 'AddedtoHubSpot_1355746',
        fieldValue: true,
        fieldLabel: 'Added to HubSpot?',
      },
    ],
    capacity: 40,
    capacityMinutes: 2400,
    defaultCapacity: true,
    meetingRecordingEnabled: false,
    calendarStatus: 'NOT_CONNECTED',
  },
  {
    userName: 'devdesai',
    emailId: 'dev.desai@webengage.com',
    userId: 362376,
    firstName: 'Dev',
    lastName: 'Desai',
    userType: 'EXTERNAL',
    accountId: 109,
    company: {
      companyId: 1524,
      companyName: 'Webengage',
      companyLogoUrl: 'https://assets.rocketlane.com/webengage.png',
      companyType: 'CUSTOMER',
      identityType: 'COMPANY',
      canTrackTime: false,
    },
    timeZone: 'Asia/Kolkata',
    role: {},
    userStatus: 'ACTIVE',
    identityType: 'USER',
    createdAt: 1732097029134,
    loginType: 'USER',
    metaData: {
      '1355746': true,
    },
    fields: [
      {
        fieldId: 1355746,
        fieldName: 'AddedtoHubSpot_1355746',
        fieldValue: true,
        fieldLabel: 'Added to HubSpot?',
      },
    ],
    capacity: 40,
    capacityMinutes: 2400,
    defaultCapacity: true,
    meetingRecordingEnabled: false,
    calendarStatus: 'NOT_CONNECTED',
  },
  {
    userName: 'sumitoj',
    emailId: 'sumitoj@verloop.io',
    userId: 363161,
    firstName: 'sumitoj',
    lastName: 'singh',
    userType: 'EXTERNAL',
    accountId: 109,
    company: {
      companyId: 514,
      companyName: 'Verloop',
      companyLogoUrl: 'https://assets.rocketlane.com/Verloop.io.png',
      companyType: 'CUSTOMER',
      identityType: 'COMPANY',
      canTrackTime: false,
    },
    timeZone: 'Asia/Calcutta',
    role: {},
    userStatus: 'ACTIVE',
    identityType: 'USER',
    createdAt: 1732186559991,
    loginType: 'USER',
    metaData: {
      '1355746': true,
    },
    fields: [
      {
        fieldId: 1355746,
        fieldName: 'AddedtoHubSpot_1355746',
        fieldValue: true,
        fieldLabel: 'Added to HubSpot?',
      },
    ],
    capacity: 40,
    capacityMinutes: 2400,
    defaultCapacity: true,
    meetingRecordingEnabled: false,
    calendarStatus: 'NOT_CONNECTED',
  },
  {
    userName: 'chandramaulil',
    emailId: 'chandramauli.l@darwinbox.in',
    userId: 348466,
    firstName: 'chandramaulil',
    userType: 'EXTERNAL',
    accountId: 109,
    company: {
      companyId: 205782,
      companyName: 'DarwinBox',
      companyLogoUrl:
        'https://d1vtr0p8bkmfca.cloudfront.net/109/9e19c2a2-c7df-4f36-9840-05e606d4da61/thedarwinbox_logo.jpeg',
      companyType: 'CUSTOMER',
      identityType: 'COMPANY',
      canTrackTime: false,
    },
    timeZone: 'Asia/Calcutta',
    role: {},
    userStatus: 'ACTIVE',
    identityType: 'USER',
    createdAt: 1729765670389,
    loginType: 'USER',
    metaData: {
      '1355746': true,
    },
    fields: [
      {
        fieldId: 1355746,
        fieldName: 'AddedtoHubSpot_1355746',
        fieldValue: true,
        fieldLabel: 'Added to HubSpot?',
      },
    ],
    capacity: 40,
    capacityMinutes: 2400,
    defaultCapacity: true,
    meetingRecordingEnabled: false,
    calendarStatus: 'NOT_CONNECTED',
  },
  {
    userName: 'jeroenbos',
    emailId: 'jeroen.bos@personio.com',
    userId: 219278,
    photoUrl:
      'https://d1vtr0p8bkmfca.cloudfront.net/109/08fa59f6-01f3-44b4-ab32-81d6bda8a06c/Profile%20pic%20Jeroen.jpeg',
    firstName: 'Jeroen',
    lastName: 'Bos',
    userType: 'EXTERNAL',
    accountId: 109,
    company: {
      companyId: 138540,
      companyName: 'Personio',
      companyLogoUrl:
        'https://d1vtr0p8bkmfca.cloudfront.net/109/794ccb03-1440-4fb4-abce-42b2dcb60823/unnamed.png',
      companyType: 'CUSTOMER',
      identityType: 'COMPANY',
      canTrackTime: false,
    },
    timeZone: 'Europe/Amsterdam',
    role: {},
    userStatus: 'ACTIVE',
    identityType: 'USER',
    createdAt: 1701283108876,
    loginType: 'USER',
    metaData: {
      '1040251': 2,
    },
    fields: [
      {
        fieldId: 1040251,
        fieldName: 'contactType',
        fieldValue: 2,
        metaFieldValue: {
          color: 'green',
          label: 'Decision maker',
          value: 2,
          group: 1,
          active: true,
          deletable: false,
          editable: false,
        },
        fieldLabel: 'Contact Type',
      },
    ],
    capacity: 40,
    capacityMinutes: 2400,
    defaultCapacity: true,
    managerOf: [235179, 236671],
    meetingRecordingEnabled: false,
    calendarStatus: 'NOT_CONNECTED',
  },
  {
    userName: 'bertaespejo',
    emailId: 'berta.espejo@personio.de',
    userId: 236666,
    photoUrl:
      'https://d1vtr0p8bkmfca.cloudfront.net/109/db679c82-8bb5-4d80-bbae-220c765d2c64/WhatsApp%20Image%202023-09-14%20at%2015.46.48.jpeg',
    firstName: 'Berta',
    lastName: 'Espejo Vigil',
    userType: 'EXTERNAL',
    accountId: 109,
    company: {
      companyId: 138540,
      companyName: 'Personio',
      companyLogoUrl:
        'https://d1vtr0p8bkmfca.cloudfront.net/109/794ccb03-1440-4fb4-abce-42b2dcb60823/unnamed.png',
      companyType: 'CUSTOMER',
      identityType: 'COMPANY',
      canTrackTime: false,
    },
    timeZone: 'Europe/Madrid',
    role: {},
    userStatus: 'ACTIVE',
    identityType: 'USER',
    createdAt: 1706531910424,
    loginType: 'USER',
    metaData: {
      '1040251': 1,
    },
    fields: [
      {
        fieldId: 1040251,
        fieldName: 'contactType',
        fieldValue: 1,
        metaFieldValue: {
          color: 'cool-gray',
          label: 'Champion',
          value: 1,
          group: 2,
          active: true,
          deletable: false,
          editable: false,
        },
        fieldLabel: 'Contact Type',
      },
    ],
    capacity: 40,
    capacityMinutes: 2400,
    defaultCapacity: true,
    reportingTo: 235179,
    managerOf: [],
    meetingRecordingEnabled: false,
    calendarStatus: 'NOT_CONNECTED',
  },
  {
    userName: 'palomasanchez',
    emailId: 'paloma.sanchez@personio.de',
    userId: 246253,
    firstName: 'Paloma',
    lastName: 'Sánchez Lucas',
    userType: 'EXTERNAL',
    accountId: 109,
    company: {
      companyId: 138540,
      companyName: 'Personio',
      companyLogoUrl:
        'https://d1vtr0p8bkmfca.cloudfront.net/109/794ccb03-1440-4fb4-abce-42b2dcb60823/unnamed.png',
      companyType: 'CUSTOMER',
      identityType: 'COMPANY',
      canTrackTime: false,
    },
    timeZone: 'Europe/Madrid',
    role: {},
    userStatus: 'ACTIVE',
    identityType: 'USER',
    createdAt: 1708949422630,
    loginType: 'USER',
    metaData: {
      '1040251': 1,
    },
    fields: [
      {
        fieldId: 1040251,
        fieldName: 'contactType',
        fieldValue: 1,
        metaFieldValue: {
          color: 'cool-gray',
          label: 'Champion',
          value: 1,
          group: 2,
          active: true,
          deletable: false,
          editable: false,
        },
        fieldLabel: 'Contact Type',
      },
    ],
    capacity: 40,
    capacityMinutes: 2400,
    defaultCapacity: true,
    reportingTo: 235179,
    managerOf: [],
    meetingRecordingEnabled: false,
    calendarStatus: 'NOT_CONNECTED',
  },
  {
    userName: 'barrypatrickkavanagh',
    emailId: 'barry.patrick.kavanagh@personio.de',
    userId: 235179,
    firstName: 'Barry',
    lastName: 'Kavanagh',
    userType: 'EXTERNAL',
    accountId: 109,
    company: {
      companyId: 138540,
      companyName: 'Personio',
      companyLogoUrl:
        'https://d1vtr0p8bkmfca.cloudfront.net/109/794ccb03-1440-4fb4-abce-42b2dcb60823/unnamed.png',
      companyType: 'CUSTOMER',
      identityType: 'COMPANY',
      canTrackTime: false,
    },
    timeZone: 'Europe/Dublin',
    role: {},
    userStatus: 'ACTIVE',
    identityType: 'USER',
    createdAt: 1706090612015,
    loginType: 'USER',
    metaData: {
      '1040251': 2,
    },
    fields: [
      {
        fieldId: 1040251,
        fieldName: 'contactType',
        fieldValue: 2,
        metaFieldValue: {
          color: 'green',
          label: 'Decision maker',
          value: 2,
          group: 1,
          active: true,
          deletable: false,
          editable: false,
        },
        fieldLabel: 'Contact Type',
      },
    ],
    capacity: 40,
    capacityMinutes: 2400,
    defaultCapacity: true,
    reportingTo: 219278,
    managerOf: [236666, 236668, 246253],
    meetingRecordingEnabled: false,
    calendarStatus: 'NOT_CONNECTED',
  },
  {
    userName: 'jessicanolte',
    emailId: 'jessica.nolte@personio.de',
    userId: 236670,
    firstName: 'Jessica',
    lastName: 'Nolte',
    userType: 'EXTERNAL',
    accountId: 109,
    company: {
      companyId: 138540,
      companyName: 'Personio',
      companyLogoUrl:
        'https://d1vtr0p8bkmfca.cloudfront.net/109/794ccb03-1440-4fb4-abce-42b2dcb60823/unnamed.png',
      companyType: 'CUSTOMER',
      identityType: 'COMPANY',
      canTrackTime: false,
    },
    timeZone: 'Europe/Dublin',
    role: {},
    userStatus: 'ACTIVE',
    identityType: 'USER',
    createdAt: 1706531932664,
    loginType: 'USER',
    metaData: {
      '1040251': 2,
    },
    fields: [
      {
        fieldId: 1040251,
        fieldName: 'contactType',
        fieldValue: 2,
        metaFieldValue: {
          color: 'green',
          label: 'Decision maker',
          value: 2,
          group: 1,
          active: true,
          deletable: false,
          editable: false,
        },
        fieldLabel: 'Contact Type',
      },
    ],
    capacity: 40,
    capacityMinutes: 2400,
    defaultCapacity: true,
    reportingTo: 236671,
    managerOf: [],
    meetingRecordingEnabled: false,
    calendarStatus: 'NOT_CONNECTED',
  },
  {
    userName: 'raikahorstmann',
    emailId: 'raika.horstmann@personio.de',
    userId: 236668,
    photoUrl:
      'https://d1vtr0p8bkmfca.cloudfront.net/109/f2dbf230-9bf7-4e4a-98b1-2d0bbaca6697/ME.jpg',
    firstName: 'Raika',
    lastName: 'Horstmann',
    userType: 'EXTERNAL',
    accountId: 109,
    company: {
      companyId: 138540,
      companyName: 'Personio',
      companyLogoUrl:
        'https://d1vtr0p8bkmfca.cloudfront.net/109/794ccb03-1440-4fb4-abce-42b2dcb60823/unnamed.png',
      companyType: 'CUSTOMER',
      identityType: 'COMPANY',
      canTrackTime: false,
    },
    timeZone: 'Europe/Berlin',
    role: {},
    userStatus: 'ACTIVE',
    identityType: 'USER',
    createdAt: 1706531921670,
    loginType: 'USER',
    metaData: {
      '1040251': 1,
    },
    fields: [
      {
        fieldId: 1040251,
        fieldName: 'contactType',
        fieldValue: 1,
        metaFieldValue: {
          color: 'cool-gray',
          label: 'Champion',
          value: 1,
          group: 2,
          active: true,
          deletable: false,
          editable: false,
        },
        fieldLabel: 'Contact Type',
      },
    ],
    capacity: 40,
    capacityMinutes: 2400,
    defaultCapacity: true,
    reportingTo: 235179,
    managerOf: [],
    meetingRecordingEnabled: false,
    calendarStatus: 'NOT_CONNECTED',
  },
  {
    userName: 'ilanfarhi',
    emailId: 'ilan.farhi@sysaid.com',
    userId: 217068,
    photoUrl:
      'https://d1vtr0p8bkmfca.cloudfront.net/109/2337085d-5529-420f-b01d-b56f0b5fff5f/ilan.jpeg',
    firstName: 'Ilan',
    lastName: 'Farhi',
    userType: 'EXTERNAL',
    accountId: 109,
    company: {
      companyId: 134974,
      companyName: 'sysaid',
      companyLogoUrl:
        'https://d1vtr0p8bkmfca.cloudfront.net/109/7d1421a1-fb93-460f-bd40-f4daf4ce6a7c/download.png',
      companyType: 'CUSTOMER',
      identityType: 'COMPANY',
      canTrackTime: false,
    },
    timeZone: 'Asia/Jerusalem',
    role: {},
    userStatus: 'ACTIVE',
    identityType: 'USER',
    createdAt: 1700793199475,
    loginType: 'USER',
    metaData: {
      '1820884': '<p>Decision Maker</p>',
    },
    fields: [
      {
        fieldId: 1820884,
        fieldName: 'Notes_1820884',
        fieldValue: '<p>Decision Maker</p>',
        fieldLabel: 'Notes',
      },
    ],
    capacity: 40,
    capacityMinutes: 2400,
    defaultCapacity: true,
    meetingRecordingEnabled: false,
    calendarStatus: 'NOT_CONNECTED',
  },
];
const mockPeopleList: PeopleListRow[] = users.map((user) => ({
  user: user as unknown as User,
  pageDocumentMappingId: 4558,
  sourceId: 189972,
  documentId: 4695,
  pageType: PageType.Meeting,
  templateId: 25,
  createdAt: '2025-07-04T10:29:58.920+0000',
  updatedAt: '2025-07-04T10:29:58.920+0000',
  accountId: 109,
  enabled: true,
  lastEngagedOn: '2025-07-04T10:29:58.920+0000',
  recentRiskSignals: [
    {
      signalName: 'Bugs',
      signalConfigurationId: 1,
      signalOccurrenceCount: 1,
      signalOccurrenceIds: [20],
    },
    {
      signalName: 'Escalations',
      signalConfigurationId: 2,
      signalOccurrenceCount: 2,
      signalOccurrenceIds: [21, 22],
    },
  ],
  recentRiskSignalWeeklyCounts: [0, 0, 0, 0, 1, 0, 0, 0, 0, 2, 0, 0],
  recentOpportunitySignals: [
    {
      signalName: 'Expansion',
      signalConfigurationId: 3,
      signalOccurrenceCount: 2,
      signalOccurrenceIds: [4, 1],
    },
    {
      signalName: 'Adoption Strategy',
      signalConfigurationId: 4,
      signalOccurrenceCount: 1,
      signalOccurrenceIds: [2],
    },
  ],
  recentOpportunitySignalWeeklyCounts: [0, 0, 0, 0, 1, 0, 0, 0, 0, 2, 0, 0],
}));
const mockPeopleProfile = (userId: number): AccountPeopleProfile => ({
  fieldsAccessMeta: { EXTERNAL_TEAM_MEMBER: [] } as unknown as FieldAccessMeta,
  firstSignalOccurredAt: '2025-07-04T10:29:58.920+0000',
  recentSignalOccurredAt: '2025-07-04T10:29:58.920+0000',
  documentSourceMappingModel: {
    pageDocumentMappingId: 4917,
    sourceId: 254922,
    documentId: 5054,
    pageType: 'PEOPLE',
    templateId: 119,
    createdAt: '2025-07-17T11:36:06.748+0000',
    updatedAt: '2025-07-17T11:36:06.746+0000',
    accountId: 109,
    enabled: true,
  },
  user: (users.find((user) => user.userId === userId) ??
    users[0]) as unknown as User,
  userEngagementData: {
    userBasedEngagementSummary: {
      summary:
        'This client meeting covered the project scope and timeline. The client expressed satisfaction with the proposed approach and agreed to proceed with the implementation in Q1 2024.',
      sourceName: 'Q1 2024 Project Kickoff Meeting',
      sourceId: 12345,
      sourceTime: '2024-01-15T10:00:00Z',
      sourceType: SourceType.Meeting,
    },
    icebreakers: [
      {
        icebreaker: 'How was your holiday vacation in Switzerland?',
        sourceName: 'Q1 2024 Project Kickoff Meeting',
        sourceId: 12345,
        sourceTime: '2024-01-15T10:00:00Z',
        sourceType: SourceType.Meeting,
      },
      {
        icebreaker:
          "I heard you're a big fan of Formula 1 racing. Did you watch the Monaco Grand Prix?",
        sourceName: 'Follow-up Discussion Call',
        sourceId: 12346,
        sourceTime: '2024-01-22T14:30:00Z',
        sourceType: SourceType.Meeting,
      },
    ],
    likesAndInterests: [
      {
        likesAndInterest:
          'Passionate about sustainable technology and green energy solutions',
        sourceName: 'Q1 2024 Project Kickoff Meeting',
        sourceId: 12345,
        sourceTime: '2024-01-15T10:00:00Z',
        sourceType: SourceType.Meeting,
      },
      {
        likesAndInterest: 'Enjoys mountain biking and outdoor adventures',
        sourceName: 'Follow-up Discussion Call',
        sourceId: 12346,
        sourceTime: '2024-01-22T14:30:00Z',
        sourceType: SourceType.Meeting,
      },
      {
        likesAndInterest:
          'Collects vintage watches and has expertise in horology',
        sourceName: 'Quarterly Business Review',
        sourceId: 12347,
        sourceTime: '2024-02-01T11:00:00Z',
        sourceType: SourceType.Meeting,
      },
    ],
  },
  userProfile: {
    enrichedUserData: {
      userExperience: [
        {
          company: {
            companyName: 'Discord',
          } as Company,
          role: 'Technical Advisor',
          startDate: '2022-05-12',
          endDate: '2023-07-07',
        },
      ],
    },
  },
});

// Mock function
export const mockSignalOccurrenceGroupedForUser = (
  userId: number,
): SignalOccurrenceGroupedForUser[] => [
  {
    userId,
    signalName: 'Security & client-data privacy safeguards',
    description: [
      'Comments must be private by default to avoid human error',
      'Clients must never see other clients’ data',
      'Disable client ability to invite extra users',
    ].join('. '),
    signalType: 'RISK' as SignalType,
    signalFrequency: 'PERSISTENT' as SignalFrequency,
    signalOccurrenceIds: [101, 102, 103],
    teamResponses: [
      {
        respondedBy: [1001],
        respondedAt: '2025-06-12T10:00:00Z',
        sourceId: 2001,
        sourceType: 'MEETING' as SourceType,
        response:
          'Support lead (Akhilesh) prioritising go-live tasks; AFLs trial kicking off Tuesday, IT doc released on 12 Jun',
      },
      {
        respondedBy: [1001],
        respondedAt: '2025-06-10T10:00:00Z',
        sourceId: 2001,
        sourceType: 'MEETING' as SourceType,
        response:
          'Support lead (Akhilesh) prioritising go-live tasks; AFLs trial kicking off Tuesday, IT doc no release date yet',
      },
    ],
    firstReportedAt: '2025-03-15T00:00:00Z',
    lastReportedAt: '2025-06-12T00:00:00Z',
  },
  {
    userId,
    signalName: 'Ticketing / Kanban & auto-assignment gaps',
    description: [
      'Need Kanban board + ticketing system for internal requests',
      'Missing Assignee field; tickets auto-assign incorrectly',
      'Ticket not visible immediately after creation',
    ].join('. '),
    signalType: 'RISK' as SignalType,
    signalFrequency: 'PERSISTENT' as SignalFrequency,
    signalOccurrenceIds: [104, 105],
    teamResponses: [
      {
        respondedBy: [1002],
        respondedAt: '2025-06-12T10:00:00Z',
        sourceId: 2002,
        sourceType: 'MEETING' as SourceType,
        response:
          'Feature request logged; Akhilesh exploring placeholder/automation workaround. No ETA provided',
      },
    ],
    firstReportedAt: '2025-04-08T00:00:00Z',
    lastReportedAt: '2025-06-12T00:00:00Z',
  },
  {
    userId,
    signalName: 'Task-description field too short',
    description:
      'One-liner description blocks complex briefs; needs long-text box.',
    signalType: 'RISK' as SignalType,
    signalFrequency: 'INTERMITTENT' as SignalFrequency,
    signalOccurrenceIds: [106],
    teamResponses: [
      {
        respondedBy: [1003],
        respondedAt: '2025-06-03T10:00:00Z',
        sourceId: 2003,
        sourceType: 'MEETING' as SourceType,
        response: 'Issue resolved and live in production',
      },
      {
        respondedBy: [1003],
        respondedAt: '2025-05-20T10:00:00Z',
        sourceId: 2003,
        sourceType: 'MEETING' as SourceType,
        response:
          'Multiline field flagged to product; Akhilesh said change is in backlog.',
      },
    ],
    firstReportedAt: '2025-04-19T00:00:00Z',
    lastReportedAt: '2025-06-03T00:00:00Z',
  },
  {
    userId,
    signalName: 'Setup & support delays jeopardising client demo',
    description:
      'Internal test environment still incomplete; demo due next Friday.',
    signalType: 'RISK' as SignalType,
    signalFrequency: 'INTERMITTENT' as SignalFrequency,
    signalOccurrenceIds: [107],
    teamResponses: [
      {
        respondedBy: [1004],
        respondedAt: '2025-06-12T10:00:00Z',
        sourceId: 2004,
        sourceType: 'MEETING' as SourceType,
        response:
          'Support team committed to finish setup before the demo date; follow-up meeting scheduled with Chris if any slip.',
      },
    ],
    firstReportedAt: '2025-04-19T00:00:00Z',
    lastReportedAt: '2025-06-12T00:00:00Z',
  },
  {
    userId,
    signalName: 'Export / extract capability for issue lists',
    description: 'Clients need to export issues to Excel for offline review.',
    signalType: 'RISK' as SignalType,
    signalFrequency: 'ONE_TIME' as SignalFrequency,
    signalOccurrenceIds: [108],
    teamResponses: [
      {
        respondedBy: [1005],
        respondedAt: '2025-06-12T10:00:00Z',
        sourceId: 2005,
        sourceType: 'MEETING' as SourceType,
        response:
          'Akhilesh noted extract not yet supported; will “check for other ways.” No update from team.',
      },
    ],
    firstReportedAt: '2025-04-19T00:00:00Z',
    lastReportedAt: '2025-06-12T00:00:00Z',
  },
];

// Mock data for V2 API
const mockPeopleV2Response: PeopleListV2 = {
  pages: [],
  fieldsAccessMeta: { EXTERNAL_TEAM_MEMBER: [] } as unknown as FieldAccessMeta,
  latestMeetingParticipantPages: [],
};

class AccountPeopleClient extends HttpClient {
  public async getPeopleList(accountId: number): Promise<PeopleListRow[]> {
    return this.get<PeopleListRow[]>(
      `/pages?pageType=PEOPLE&companyId=${accountId}`,
    ).catch(() => mockPeopleList);
  }
  public async getPeopleV2(accountId: number): Promise<PeopleListV2> {
    return this.get<PeopleListV2>(
      `/pages/v2?pageType=PEOPLE&companyId=${accountId}`,
    ).catch(() => mockPeopleV2Response);
  }
  public async getPeopleProfile(userId: number): Promise<AccountPeopleProfile> {
    return this.get<AccountPeopleProfile>(
      `/scarlet/users/${userId}/profile`,
    ).catch(() => mockPeopleProfile(userId));
  }
  public async getSignalOccurrenceGroupedForUser(
    payload: GetSignalOccurrenceGroupedForUserPayload,
  ): Promise<SignalOccurrenceGroupedForUserPaginated> {
    return this.get<SignalOccurrenceGroupedForUserPaginated>(
      `/scarlet/users/${payload.userId}/signal-occurrences-grouped`,
      {
        params: {
          ['signalType.value']: payload.signalType,
          ['lastReportedAt.greaterThanEqual']: payload.from,
          ['lastReportedAt.lessThanEqual']: payload.to,
          limit: payload.limit,
          offset: payload.offset,
          sort: payload.sort ?? 'signalFrequency.desc',
        },
      },
    ).catch(() => {
      const signalOccurrences = mockSignalOccurrenceGroupedForUser(
        payload.userId,
      );

      return {
        data: signalOccurrences,
        count: signalOccurrences.length,
      };
    });
  }
}

export const AccountPeopleAPI = new AccountPeopleClient();
